import { forwardRef, type Ref, type SVGProps } from "react";
const IconVideoPlayFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28 4H4a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M17 6h2v3h-2Zm-4 0h2v3h-2ZM7 26H5v-3h2ZM7 9H5V6h2Zm4 17H9v-3h2Zm0-17H9V6h2Zm4 17h-2v-3h2Zm4 0h-2v-3h2Zm.51-9-6.06 3.91A.9.9 0 0 1 13 21a.9.9 0 0 1-.49-.15 1.12 1.12 0 0 1-.48-1V12.1a1.12 1.12 0 0 1 .48-.95.88.88 0 0 1 1 0l6.06 3.91a1.17 1.17 0 0 1 0 1.9ZM23 26h-2v-3h2Zm0-17h-2V6h2Zm4 17h-2v-3h2Zm0-17h-2V6h2Z" />
  </svg>
);
const ForwardRef = forwardRef(IconVideoPlayFilledSVG);
ForwardRef.displayName = "IconVideoPlayFilled";
export { ForwardRef as IconVideoPlayFilled };
